import React from "react";

const trustItems = [
  "Serving All of Hyderabad",
  "Gachibowli • Kondapur • Madhapur",
  "Narsingi • Banjara Hills • Jubilee Hills",
  "Trusted by Builders & Architects",
  "Quality Materials • Expert Craftsmanship",
  "20-45 Day Delivery",
  "Your Space, Our Care",
];

export default function TrustStrip() {
  const duplicatedItems = [...trustItems, ...trustItems];

  return (
    <section className="py-6 bg-brand-primary overflow-hidden">
      <div className="relative">
        <div className="flex animate-marquee hover:[animation-play-state:paused]">
          {duplicatedItems.map((item, index) => (
            <div
              key={index}
              className="flex items-center px-8 whitespace-nowrap"
            >
              <span className="text-white/90 font-medium">{item}</span>
              <span className="w-2 h-2 bg-brand-accent rounded-full ml-8" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
